import { render, staticRenderFns } from "./FormPrinciple.vue?vue&type=template&id=4ac9f787&scoped=true&"
import script from "./FormPrinciple.vue?vue&type=script&lang=js&"
export * from "./FormPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./FormPrinciple.vue?vue&type=style&index=0&id=4ac9f787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9f787",
  null
  
)

export default component.exports